import { useTracking } from 'opensolar-common'
import { OSSDK } from 'opensolar-sdk'
import { useCallback, useEffect, useRef, useState } from 'react'

export type TrackEventParams = {
  type: string
  action: { type: string; status?: string }
  name: string
  additionalData?: Record<string, any>
}

type QueuedEvent = TrackEventParams

const useTrackingBindings = ({ active, sdk }: { sdk: OSSDK; active: boolean }) => {
  const { dispatchEvent, resolveUiKey } = useTracking()

  const eventQueue = useRef<QueuedEvent[]>([])
  const [queueVersion, setQueueVersion] = useState(0)

  const dispatchTrackingEvent = useCallback(
    (args: TrackEventParams) => {
      const { type, action, name, additionalData = {} } = args

      dispatchEvent({
        key: additionalData.key || name,
        type: type as any,
        name,
        action: action as any,
        additionalData,
      })
    },
    [dispatchEvent]
  )

  useEffect(() => {
    if (!active) return

    if (eventQueue.current.length > 0) {
      console.log(`[useTrackingBindings] Processing ${eventQueue.current.length} queued events`)

      eventQueue.current.forEach((event) => {
        dispatchTrackingEvent(event)
      })

      eventQueue.current = []
      setQueueVersion((v) => v + 1)
    }
  }, [active, dispatchTrackingEvent, queueVersion])

  useEffect(() => {
    if (!active) return

    sdk.tracker.trackEvent.own(async (args: TrackEventParams) => {
      dispatchTrackingEvent(args)
    })
  }, [active, dispatchTrackingEvent])
}

export default useTrackingBindings
